export default "__VITE_ASSET__387546c1__"